exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".LocaleSwitcherBump-4ac87e4b{padding:10px}.LocaleSwitcherBump-4ac87e4b .header-0398897a{font-weight:bold;font-size:14px;line-height:18px;margin-bottom:5px}.LocaleSwitcherBump-4ac87e4b .body-c16d9d45{font-size:13px;line-height:17px;padding-bottom:10px}.LocaleSwitcherBump-4ac87e4b a.dismiss-e48dd587{text-align:left;font-weight:500;font-size:13px}\n", ""]);

// Exports
exports.locals = {
	"LocaleSwitcherBump": "LocaleSwitcherBump-4ac87e4b",
	"header": "header-0398897a",
	"body": "body-c16d9d45",
	"dismiss": "dismiss-e48dd587"
};